import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import formFinderBuilder from './formFinderBuilder';
import formFinders from './formFinders';
import formBuilder from './formBuilder';
import forms from './forms';
import fieldDialog from './fieldDialog';
import stepDialog from './stepDialog';
import site from './site';
import authentication from './authentication';
import navDrawer from './navDrawer';

export default (history) =>
    combineReducers({
        router: connectRouter(history),
        fieldDialog,
        formFinderBuilder,
        formFinders,
        formBuilder,
        forms,
        stepDialog,
        site,
        authentication,
        navDrawer,
    });
